let TOOLS = TOOLS || {};

TOOLS.LIST_CAROUSEL = {
  init: function () {
    let self = this;

    self.initCarousel();
  },

  initCarousel: function() {
    let self = this;

    if ($('.js-carousel-container').length) {
      // オブザーバー生成
      const options = {
        root: null,
        rootMargin: '420px 0px',
        threshold: [0,0],
      };
      const observer = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry, i) {
          // 交差していない
          if (!entry.isIntersecting) return;

          // 未初期化
          if (!entry.target.classList.contains('js-carousel-loaded')) {
            self.createCarousel($(entry.target));
          }
        })
      }, options);

      // 監視
      $('.js-carousel-container').each(function() {
        observer.observe($(this)[0]);
      });
    }
  },

  createCarousel: function(_container) {
    let self = this;
    // 各要素を取得
    let $container = _container;
    let $main = $container.find('.js-carousel-main');
    let $nav = $container.find('.js-carousel-nav');

    // 初期化済みの印をつける
    $container.addClass('js-carousel-loaded');

    // IDを設定
    const S="abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    const N=16;
    const cryptoObj = window.crypto || window.msCrypto;
    const randomIndexArr = cryptoObj.getRandomValues(new Uint8Array(N));
    let id = '';
    for(let i = 0; i < N; i++) {
      id = id + S[randomIndexArr[i]%S.length];
    }
    $main.attr('data-carousel-id', 'main-' + id);
    $nav.attr('data-carousel-id', 'nav-' + id);

    // 実行
    $main.slick({
      dots: false,
      infinite: true,
      swipeToSlide: true,
      speed: 500,
      fade: true,
      cssEase: 'linear',
      lazyLoad: 'ondemand',
      asNavFor: '[data-carousel-id=nav-' + id + ']',
    });
    $nav.slick({
      dots: false,
      slidesToShow: 6,
      slidesToScroll: 6,
      swipeToSlide: true,
      asNavFor: '[data-carousel-id=main-' + id + ']',
      centerMode: false,
      focusOnSelect: true,
      lazyLoad: 'ondemand',
      variableWidth: true,
    });
  }
}


TOOLS.OHKURAYA_CAROUSEL = {

  init: function () {
    let self = this;

    self.initCarousel();
  },

  initCarousel: function() {
    let self = this;

    if ($('.js-search-ohkuraya-carousel').length) {

      $('.js-search-ohkuraya-carousel').slick({
        dots: true,
        infinite: true,
        swipeToSlide: false,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 1000,
        fade: true,
        cssEase: 'linear',
        lazyLoad: 'ondemand',
      });
    }
  },
}

TOOLS.LIST_TYPE_CONTROLLER = {
  mode: null,

  init: function() {
    let self = this;

    // モード取得
    self.mode = $('.js-list-type-controller-container').attr('data-mode');

    // クリック時のイベント
    $('.js-list-type-controller').on('click', function() {
      if (!$(this).hasClass('--is-active')) {
        // 選択状況取得
        const type = $(this).attr('data-list-type');

        // クッキー更新
        self.writeCookie(type);

        // 対象のページに遷移
        self.changePage(type);
      }
    });
  },

  /**
   * Cookieへの書き込み
   * @param type
   */
  writeCookie: function(type) {
    if (type !== 'map') {
      const cookieName = $('#list-type-cookie').val();
      $.cookie(cookieName, type, {expires: 7, path: '/', secure: true});
    }
  },

  /**
   * 現在のページのURLをmap/list用に書き換えて画面遷移
   * @param type
   */
  changePage: function (nextType) {
    let self = this;
    const currentType = $('.js-list-type-controller.--is-active').attr('data-list-type');
    let currentHref = location.href;
    if (
      (currentType == 'small' && nextType == 'large')
      || (currentType == 'large' && nextType == 'small')
    ) {
      // URLに変更がないのでリロード
      location.reload();
    } else if (nextType == 'map') {
      // 地図用にURL変換
      currentHref = currentHref.replace(/&?page=\d+/, '')
      console.log(currentHref, self.mode);
      switch (self.mode) {
        case 'selection' :
          location.href = currentHref.replace(/selection/, 'selection/map');
          break;
        default:
          location.href = currentHref.replace(/search/, 'search/map');
      }
    } else {
      // 一覧用にURL変換
      switch (self.mode) {
        case 'selection' :
          location.href = currentHref.replace(/selection\/map/, 'selection');
          break;
        default:
          location.href = currentHref.replace(/search\/map/, 'search');
      }
    }
  }
}

TOOLS.CONDITIONS_MODAL = {

  /**
   * 初期処理
   */
  init: function () {
    let self = this;

    $('.js-conditions-modal-trigger').on('click', function() {
      $('.js-conditions-modal').modal();
    });

    $('form.js-form-conditions-modal').on('submit', function(e) {
      // サブミット時のパラメータ変換
      self.convertParams();
    });
  },

  /**
   * サブミット時のパラメータ変換
   */
  convertParams: function() {
    let self = this;
    const $wrap = $('.js-conditions-modal');

    // プルダウン項目
    $.each(['price_from', 'price_to', 'area_from', 'area_to', 'walk_time', 'age_of_building'], function(i, _name) {
      const value = $wrap.find('[name=' + _name + '] option:selected').val();
      self.updateHidden(_name, value);
    });

    // チェックボックス項目
    $.each(['property_type','layout', 'detail'], function(i, _name) {
      let values = [];
      $wrap.find('[name=' + _name + ']:checked').each(function() {
        values.push($(this).val());
      });
      self.updateHidden(_name, values.join('-'));
    });

    // ラジオボタン項目
    $.each(['reform_renovation'], function(i, _name) {
      const value = $wrap.find('[name=' + _name + ']:checked').val();
      self.updateHidden(_name, value);
    });

    // テキストボックス項目
    $.each(['free_word'], function(i, _name) {
      const value = $wrap.find('[name=' + _name + ']').val()
      self.updateHidden(_name, value);
    });

    return false;
  },

  /**
   * 値をhiddenに設定
   * ※初期表示時にはhidden要素がないが、submit後にブラウザバックした場合、iPhoneでは値が残っているのでそれを考慮して要素の存在チェックが必要。
   * @param _key
   * @param _value
   */
  updateHidden: function(_key, _value) {
    let self = this;
    console.log(_key, _value);
    let $form = $('.js-form-conditions-modal');
    let $target = $form.find('input[type=hidden][name=' + _key + ']');
    if (_value != '') {
      if ($target.length) {
        $target.val(_value);
      } else {
        let $input = $('<input>', {
          type: 'hidden',
          name: _key,
          value: _value,
        });
        $form.append($input);
      }
    } else {
      $target.remove();
    }
  }
}

TOOLS.SORT = {
  init: function() {
    let self = this;
    $('.js-search-sort').on('change', function() {
      self.changeSort($(this).val());
    })
  },
  changeSort: function(_sort) {
    let url = location.href;
    url = url.replace(/&?sort=\d/,''); // 既存ソートをクリア
    url = url.replace(/&?page=\d+/, ''); // ページ番号クリア
    url = url.replace(/#.*/, ''); // ハッシュ削除
    if (url.match(/\?/)) {
      url += '&sort=' + _sort;
    } else {
      url += '?sort=' + _sort;
    }
    location.href = url;
  },
}

TOOLS.CONDITIONS_REGISTER = {

  init: function() {
    let self = this;

    $('.js-condition-register-btn').on('click', function() {
      console.log('js-condition-register-btn');
      let url = $(this).attr('data-api-url');

      data = [];
      $.ajax(url, {
        type: "post",
        data: data,
        dataType: "json",
        headers: {
          'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
        },
      }).done(function(data) {
        console.log('js-condition-register-btn-end');
        alert('検索条件を保存しました');
      });
    });
  },
}

$(function() {
  TOOLS.LIST_TYPE_CONTROLLER.init();
  TOOLS.CONDITIONS_MODAL.init();
  TOOLS.SORT.init();
  TOOLS.CONDITIONS_REGISTER.init();
  TOOLS.LIST_CAROUSEL.init();
  TOOLS.OHKURAYA_CAROUSEL.init();
});
